﻿//import { useMsal, useAccount } from "@azure/msal-react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { requiredScopes } from './msalConfig';


export const getAuthToken = async (authConfig) => {
    const { instance, account, inProgress, scopes } = authConfig;

    if (account && inProgress === "none") {
        try {
            let authResult = await instance.acquireTokenSilent({
                scopes: scopes,
                account: account
            });
            return authResult;
        } catch (error) {
            // in case if silent token acquisition fails, fallback to an interactive method
            if (error instanceof InteractionRequiredAuthError) {
                if (account && inProgress === "none") {
                    const authResult = await instance.acquireTokenRedirect({
                        scopes: scopes,
                    });
                    return authResult;
                }
            }
            console.error(error);
        }
    }
    return null;
}

export const useAuthConfig = (scopes = requiredScopes) => {
    // const { instance, accounts, inProgress } = useMsal();
    // const account = useAccount(accounts[0] || {});
    // return { instance, account, inProgress, scopes };
    return null;
}
